module.exports = __webpack_public_path__ + "static/media/bbc__news_uk-politics-36615028_plot.84fe8fcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/bbc__news_uk-politics-36615028_plot.png
// module id = 342
// module chunks = 0